"use client";

import { useMemo } from "react";
import { useHydrationSafeFeatureFlagEnabled } from "@/hooks/useHydrationSafeFeatureFlagEnabled";
import {
  resolveWingmanRouting,
  WINGMAN_V2_FLAG_KEY,
  type WingmanRouting,
} from "@/services/wingman";

export function useWingmanRouting(model?: string | null): WingmanRouting {
  const v2Enabled = useHydrationSafeFeatureFlagEnabled(WINGMAN_V2_FLAG_KEY);
  return useMemo(() => resolveWingmanRouting(v2Enabled, model), [v2Enabled, model]);
}

/** True when this session would talk to Wingman v2 (flag, Europe, or auto). */
export function useWingmanV2Active(model?: string | null): boolean {
  return useWingmanRouting(model).apiVersion === "v2";
}
